"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderDesktop = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var logo = "data:image/svg+xml;base64,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";
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    header: {
      height: 64
    },
    logo: {
      padding: 0
    },
    search: _defineProperty({
      backgroundColor: (0, _styles.fade)(theme.palette.common.white, 0.95),
      border: '1px solid',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: 4
    }, theme.breakpoints.down(835), {
      backgroundColor: (0, _styles.fade)(theme.palette.common.white, 0.95),
      position: 'relative',
      margin: 'auto',
      border: '1px solid',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      height: 36,
      minWidth: 388,
      borderRadius: 4
    }),
    searchIcon: {
      padding: theme.spacing(0.7, 2.5),
      hight: 17,
      width: 17,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'black'
    },
    inputInput: _defineProperty({
      padding: theme.spacing(1, 1, 1, 0),
      marginLeft: 40
    }, theme.breakpoints.down(835), {
      padding: theme.spacing(1, 1, 1, 0),
      marginLeft: 40
    }),
    primaryText: {
      color: theme.palette.text.primary,
      width: 200
    },
    secondaryText: {
      color: theme.palette.text.secondary,
      fontSize: 14
    },
    avatar: {
      position: 'relative',
      left: 0,
      padding: 0,
      marginLeft: 24
    },
    menu: {
      marginTop: 48
    },
    menuAvatar: {
      marginRight: 16
    },
    menuIcons: {
      marginRight: 24,
      marginLeft: 8
    }
  };
});

var HeaderDesktop = function HeaderDesktop(_ref) {
  var initials = _ref.initials,
      user = _ref.user,
      email = _ref.email,
      onClickHome = _ref.onClickHome,
      searchPlaceHolder = _ref.searchPlaceHolder,
      searchWidth = _ref.searchWidth,
      searchMargin = _ref.searchMargin,
      searchMaxWidth = _ref.searchMaxWidth,
      onKeyDownDesktopSearch = _ref.onKeyDownDesktopSearch,
      menuItems = _ref.menuItems;
  var classes = useStyles();

  var _React$useState = _react.default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleMenu = function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  function listUser(userText, length) {
    var text = userText;

    if (text.length <= length) {
      return text;
    }

    text = text.substring(0, length);
    return "".concat(text, "...");
  }

  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.logo,
    onClick: onClickHome
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "logo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.search,
    style: {
      width: "".concat(searchWidth, "%"),
      margin: searchMargin,
      maxWidth: searchMaxWidth
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.searchIcon
  }, /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, null)), /*#__PURE__*/_react.default.createElement(_core.InputBase, {
    placeholder: searchPlaceHolder,
    fullWidth: true,
    classes: {
      input: classes.inputInput
    },
    onKeyDown: onKeyDownDesktopSearch
  })), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.avatar,
    onClick: handleMenu
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, null, initials)), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    className: classes.menu,
    anchorEl: anchorEl,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: open,
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    style: {
      marginTop: '8px'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.menuAvatar
  }, initials), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.primaryText
  }, listUser(user, 24), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.secondaryText
  }, listUser(email, 28)))), menuItems.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      onClick: item.onClick,
      key: item.label
    }, item.nodeIcon, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.primaryText,
      style: {
        fontSize: '14px'
      }
    }, item.label));
  }))));
};

exports.HeaderDesktop = HeaderDesktop;
HeaderDesktop.propTypes = {
  /**
   * Iniciais que serao mostradas no avatar do usuario
   */
  initials: _propTypes.default.string,

  /**
   * Nome do usuário exibido ao clicar no menu
   */
  user: _propTypes.default.string,

  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string,

  /**
   * Função requerida para quando o usuário clicar no logotipo presente no header.
   */
  onClickHome: _propTypes.default.func.isRequired,

  /**
   * Mensagem que aparecerá como placeholder da barra de pesquisa
   */
  searchPlaceHolder: _propTypes.default.string,

  /**
   * Função requerida para quando o usuário pressionar alguma tecla na barra de pesquisa
   */
  onKeyDownDesktopSearch: _propTypes.default.func.isRequired,

  /**
   *  Valor que determina em % o tamanho da barra de pesquisa dentro do header
   */
  searchWidth: _propTypes.default.number,

  /**
   * Prop que determina as margens da barra de pesquisa, podendo passar uma string como "0 100px 0 100px", caso as margens sejam de tamanhos iguais, é possivel apenas passar o valor desejado em pixels
   */
  searchMargin: _propTypes.default.string,

  /**
   *  Valor que determina o valor maximo, em pixels, que a barra de pesquisa pode alcançar
   */
  searchMaxWidth: _propTypes.default.number,

  /**
   * Lista de objetos que serão concatenados ao menu (aberto ao clicar no avatar).
   */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired
};
HeaderDesktop.defaultProps = {
  initials: 'SE',
  email: 'email@somoseducacao.com.br',
  user: 'Saraiva Educacao',
  searchPlaceHolder: 'Buscar...',
  searchWidth: 50,
  searchMargin: 'auto',
  searchMaxWidth: 931
};
var _default = HeaderDesktop;
exports.default = _default;